import { Page } from 'layouts/Page';
import { FC } from 'react';
import { Order } from 'components/Order';

export const OrderPage: FC = () => {
	return (
		<Page title="Order – EAS Dashboard">
			<Order />
		</Page>
	);
};
